import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL_GLOBAL } from 'src/environments/environment';
import { AuthService } from '../vos/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  constructor(private http: HttpClient, private authService: AuthService) { }

  getUnidadeMedidas(): Observable<any[]> {
    return this.http.get<any[]>(`${URL_GLOBAL}/categories`);
  }
  // Rotas novas para Products
  getCategories(): Observable<Array<any>> {
    return this.http.get<Array<any>>(`${URL_GLOBAL}/categories`, { headers: this.authService.userToken() })
  }
  saveCategories(data: any): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/category`, data, { headers: this.authService.userToken() });
  }
  updateCategories(id: any, data: any): Observable<any> {
    return this.http.put<any>(`${`${URL_GLOBAL}/category`}/${id}`, data, { headers: this.authService.userToken() });
  }
}
